// KPO-174 helper: returns true when a person has no zipCode set.
// Handles self-registered users where `address` exists as `{}` but no
// zipCode field is filled — see zipcode.test.js.
export const hasEmptyZipCode = (data) => {
  return !(data.address?.zipCode?.length > 0);
};
